import generic_backend_request_post from 'functions/server/generic_backend_request_post';

/**
 * Save items to the library. Batched — the backend rejects the WHOLE request if
 * it would breach the plan's per-type limit, so a partial save cannot surprise
 * the caller.
 *
 * Each item: `{item_type, name, tags, coordinate_system?, payload,
 * source_model_type?}`. `coordinate_system` is required for locations and
 * rejected on the other two types. `payload` holds display values only — build
 * it with `toPortableRow` so no scenario-local id travels with it.
 *
 * @param {Array<Object>} items - Up to 100.
 * @returns {Promise<{items: Array<Object>}>} The stored records, ids assigned.
 */
async function saved_items_create(items) {
  return generic_backend_request_post({ items }, '/saved_items_create');
}

export default saved_items_create;
